import { Pie, PieChart, ResponsiveContainer, Cell, Tooltip } from "recharts";

import type FixMeLater from "../../../shared/types/fixMeLater.type";
import type { CustomizedLabelProps, CustomTooltipProps, PieChartProps } from "../../../shared/interface/dashboard.interface";

const ParkingOccupancyPieChart = ({ data }: PieChartProps) => {
  const COLORS = ["green", "rgb(38, 92, 170)", "rgb(169, 169, 169)", "#f4cc07"];

  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: CustomizedLabelProps) => {
    if (percent > 0) {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text x={x} y={y} fill="white" fontSize="12px" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
          {`${(percent * 100).toFixed(1)}%`}
        </text>
      );
    }
    return null; 
  };

  /* custom tool tip */
  const CustomTooltip = ({ active, payload }: CustomTooltipProps) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="custom-tooltip" style={{ border: "1px solid grey", background: "rgba(255, 255, 255, 0.9)", color: "#5484BE", textAlign: "center", padding: "9px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "5px" }}>
          <p className="label" style={{ margin: 0 }}>{`${data.name}: ${data.value}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%">
      <PieChart margin={{ top: 0, left: 0, right: 0, bottom: 0 }}>
        <Tooltip content={<CustomTooltip />} />

        <Pie dataKey="value" data={data ?? []} labelLine={false} label={renderCustomizedLabel} animationBegin={0} animationDuration={0} fill="#003366">
          {data?.map((entry: FixMeLater, index: number) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ParkingOccupancyPieChart;

